const ContentParagraph = ({className, content}: { className?: string, content: string }) => {
    return <div className={className}>
        {
            content?.split('\n').map((text, index) =>
                <p
                    key={index}
                    className={`text-[1rem] ${index === 0 ? '' : 'mt-2'}`}
                >
                    {text}
                </p>
            )
        }
    </div>
}

export default ContentParagraph;